import { render, staticRenderFns } from "./PolicyViewModal.vue?vue&type=template&id=4245e410"
import script from "./PolicyViewModal.vue?vue&type=script&lang=js"
export * from "./PolicyViewModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyViewModal.vue?vue&type=style&index=0&id=4245e410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports